import MetadataUtils from '../../utils/utils-metadata';
import { ProductClass } from '../../../store/constants';
import { LocationDescriptor } from 'history';

export function buildInfoBadgeLinks(
    productClass: ProductClass,
    infoBadges: ReadonlyArray<{ readonly title: string; readonly filter: string; key: string }>,
    // TODO extract type LoanFormatKey
    loanFormatKey: string | undefined | null,
    language: string
): ReadonlyArray<{ readonly title: string; readonly link: LocationDescriptor; key: string }> {
    if (Array.isArray(infoBadges)) {
        return infoBadges.map(infoBadge => ({
            title: infoBadge.title,
            key: infoBadge.key,
            link: MetadataUtils.createMetaDataLink(productClass, infoBadge.filter, {
                loanFormatKey,
                language
            })
        }));
    }
    return [];
}
